import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import ChatToggle from '../chat/ChatToggle';

const ROUTES_WITH_JULIA_PANEL = [
  '/dashboard',
  '/structure',
  '/employes',
  '/obligations',
];

const Layout: React.FC = () => {
  const location = useLocation();
  const showFloatingChat = !ROUTES_WITH_JULIA_PANEL.some(
    (route) => location.pathname === route || location.pathname.startsWith(`${route}/`)
  );

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar />
      <main
        style={{
          flex: 1,
          marginLeft: 'var(--sidebar-width)',
          background: 'var(--color-bg)',
          minHeight: '100vh',
          minWidth: 0,
        }}
      >
        <Outlet />
      </main>
      {showFloatingChat && <ChatToggle />}
    </div>
  );
};

export default Layout;
